<template>
  <div>
    <template v-if="interview.type === types.ONLINE_INTERVIEW">
      <OnlineInterview
        :vacancy="vacancy"
        :candidate="candidate"
        :interview="interview"
        :key="key"
        :are-questions-equal="areQuestionsEqual"
        @online-interview-played="$emit('online-interview-played')"
      />
    </template>
    <template v-else-if="interview.type === types.VIDEO_CALL">
      <VideoCall
        :candidate="candidate"
        :interview="interview"
        :key="key"
      />
    </template>
    <template v-else-if="interview.type === types.OFFICE_INTERVIEW">
      <OfficeInterview
        :vacancy="vacancy"
        :readonly="readonly"
        :candidate="candidate"
        :interview="interview"
        :key="key"
      />
    </template>
    <template v-else-if="interview.type === types.UPLOADED_VIDEO">
      <UploadedVideoInterview
        :candidate="candidate"
        :interview="interview"
        :key="key"
      />
    </template>
  </div>
</template>

<script>
import { candidateInterviewType } from '@/enums';
import OnlineInterview from '@/components/Candidate/Interview/OnlineInterview';
import VideoCall from '@/components/Candidate/Interview/VideoCall';
import OfficeInterview from '@/components/Candidate/Interview/OfficeInterview';
import UploadedVideoInterview from '@/components/Candidate/Interview/UploadedVideoInterview';

export default {
  name: 'CandidateInterview',
  components: {
    UploadedVideoInterview, OfficeInterview, VideoCall, OnlineInterview,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    interview: {
      type: Object,
      required: true,
    },
    areQuestionsEqual: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      types: candidateInterviewType,
    };
  },
  computed: {
    key() {
      return Date.now();
    },
  },
};
</script>

<style scoped>

</style>
